import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { dataFieldsService, FieldType } from 'src/services';

export const filtersContainerActions = {
  navigateTo: createAction<{ navigateTo: string }>('FiltersContainer/NavigateTo'),
  errorNotification: createAction<{ customMessage: string }>(`FiltersContainer/error`),
  getDataFields: createAsyncThunk(
    'FiltersContainer/GetDataFields',
    async (
      { shopId, fieldType }: { shopId: number; fieldType: FieldType },
      { rejectWithValue }
    ) => {
      try {
        const dataFields = await dataFieldsService.getDataFields({ shopId, fieldType });
        return { shopId, dataFields };
      } catch (error) {
        return rejectWithValue({ error });
      }
    }
  ),
};
